export class QuestionnaireTemplateDraftDeleteRequest {
    templateId: string
    constructor(templateId: string) {
      this.templateId = templateId
    }
}
